import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import TabsHeader from 'components/UI/TabsHeader/TabsHeader';
import Button from 'components/UI/V2/Button/Button';
import { FunctionComponent } from 'react';
import clsx from 'clsx';

interface TabsProps {
    tabId: string;
    selectTabHandler: (tabId: string) => void;
}

// Define estilos personalizados
const useStyles = makeStyles(() =>
    createStyles({
        tabsHeaderContainer: {
            marginTop: '24px',
            borderBottom: '2px solid #E5E5E5'
        },
        tabContainer: {
            paddingBottom: '16px'
        },
        tabLabel: {
            fontSize: '14px',
            fontWeight: 500
        },
        tabsContainer: {
            display: 'flex',
            borderRadius: '100px',
            padding: '4px',
            width: '125px',
            height: '40px',
            background: '#F8F8F8',
            backgroundColor: '#F8F8F8',
            gap: '20px',
            alignItems: 'center',
            marginBottom: '30px'
        },
        tab: {
            'display': 'flex',
            'alignItems': 'center',
            'justifyContent': 'center',
            'backgroundColor': '#F8F8F8',
            'width': '48px',
            'height': '32px',
            'cursor': 'pointer',
            '&:hover': {
                backgroundColor: '#92B4A7 !important'
            }
        },
        tabActive: {
            'background': '#92B4A7',
            'borderRadius': '100px',
            '&:hover': {
                backgroundColor: '#92B4A7 !important'
            }
        },
        positiveTab: {
            // color: '#4caf50'
        },
        negativeTab: {
            //color: '#ff9800',
        },
        iconContainer: {
            width: 32,
            height: 32,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '16px'
        },
        positiveIconBg: {
            backgroundColor: 'rgba(76, 175, 80, 0.1)'
        },
        negativeIconBg: {
            backgroundColor: 'rgba(255, 152, 0, 0.1)'
        }
    })
);

export const positiveTabId = 'positive';
export const negativeTabId = 'negative';

export const Tabs: FunctionComponent<TabsProps> = props => {
    const classes = useStyles();

    const tabs = [
        { id: positiveTabId, name: '👍' },
        { id: negativeTabId, name: '👎' }
    ];

    return (
        <>
            <Box className={classes.tabsContainer}>
                <Button
                    className={clsx(classes.tab, classes.positiveTab, {
                        [classes.tabActive]: props.tabId === positiveTabId
                    })}
                    onClick={() => props.selectTabHandler && props.selectTabHandler(positiveTabId)}
                    label="👍"
                />

                <Button
                    className={`${classes.tab} ${
                        props.tabId === negativeTabId ? `${classes.tabActive} ${classes.negativeTab}` : ''
                    }`}
                    onClick={() => props.selectTabHandler && props.selectTabHandler(negativeTabId)}
                    label="👎"
                />
            </Box>
        </>
    );
};

export default Tabs;
